import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasRoutePermission } from '../utils/permissions';

/**
 * Componente para proteger rotas com base em permissões de cargo
 * Estende o conceito de PrivateRoute adicionando verificação de cargo
 * 
 * @param {Object} props - Propriedades do componente
 * @param {React.ReactNode} props.children - Componente filho a ser renderizado se autorizado
 * @param {string} props.path - Caminho da rota atual para verificação de permissão
 * @returns {React.ReactNode} - O componente filho ou redirecionamento
 */
const RoleRoute = ({ children, path }) => {
  const { signed, loading, user } = useAuth();
  
  useEffect(() => {
    // console.log('RoleRoute - Informações do usuário:', { 
    //   cargo: user?.cargo,
    //   path,
    //   signed,
    //   loading,
    //   userExists: !!user
    // });
  }, [user, path, signed, loading]);
  
  // Se ainda está carregando, mostra indicador de carregamento
  if (loading) {
    // console.log('RoleRoute - Carregando informações do usuário...');
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Carregando...
      </div>
    );
  }
  
  // Se não estiver autenticado, redireciona para login
  if (!signed) {
    console.log('RoleRoute - Usuário não autenticado, redirecionando para login');
    return <Navigate to="/login" />;
  }
  
  // Se o usuário não tiver um cargo definido, considera não autorizado
  if (!user || !user.cargo) {
    console.log('RoleRoute - Usuário não possui cargo definido:', user);
    return <Navigate to="/unauthorized" />;
  }
  
  // Verifica se o usuário tem permissão para acessar a rota
  const hasPermission = hasRoutePermission(path, user.cargo);
  // console.log(`RoleRoute - Verificação de permissão para ${path}: ${hasPermission}, cargo: ${user.cargo}`);
  
  // Se não tiver permissão, redireciona para página de não autorizado
  if (!hasPermission) {
    // console.log(`RoleRoute - Acesso negado para ${user.cargo} na rota ${path}`);
    return <Navigate to="/unauthorized" />;
  }
  
  // Se tiver permissão, renderiza o componente filho
  // console.log(`RoleRoute - Acesso autorizado para ${user.cargo} na rota ${path}`);
  return children;
};

export default RoleRoute; 